module.exports = __webpack_public_path__ + "static/media/S3N5-6.e7bba2b9.svg";